<template>
  <div class="common_wrap bg_grey">
    <div
      v-if="status === 0"
      class="error_state"
    >
      活动将于{{ actInfo.startTime }}开始
    </div>
    <div
      v-else-if="status === 2 || (status === 1 && (!bindUser || !actInfo.white))"
      class="error_state"
    >
      <div
        v-if="status === 1 && !bindUser"
        class="rule_btn pointer right_top"
        @click="handleShowRule(1)"
      >活动规则</div>
      {{ status === 1 && !bindUser ? '' : '活动已结束' }}
    </div>
    <div
      v-if="status === 1 && bindUser && actInfo.white"
      class="wrap"
    >
      <div
        class="header relative"
      >
        <img :src="actInfo.icon" />
      </div>
      <div class="account relative" style="transform: translateY(-3px);">
        <div class="amount_top flex_between pl_24 pr_24 color_white">
          <!-- <div class="account_info">游戏角色：{{ actInfo.username }}</div> -->
          <div class="account_info">已绑定角色</div>
          <div class="rule_btn pointer" @click="handleShowRule(3)">活动规则</div>
        </div>
        <div class="amount flex_center">
          <div class="amount_symbol fs_16">￥</div>
          <div
            class="amount_digit"
            :class="{ fs_28: actInfo.rechargeMoney >= 1e6 }"
          >{{ actInfo.rechargeMoney || 0 }}</div>
        </div>
        <img :src="require('@/assets/payAmount/accumulate.jpg')" alt="">
      </div>
      <div
        class="gift_wrap bg_contain"
        style="transform: translateY(-15px);"
        :style="{
          backgroundImage: `url(${require('@/assets/payAmount/giftList.jpg')})`
        }"
      >
        <div
          class="time bg_contain relative"
          :style="{
            backgroundImage: `url(${require('@/assets/payAmount/time.png')})`
          }"
        >
          <div class="time_content">活动剩余时间：{{ countdown }}</div>
        </div>
        <div
          class="gift_list"
          style="transform: translateY(-12px);"
          @touchstart.stop
          @touchmove.stop
        >
          <div
            v-for="gf in giftList"
            :key="gf.activityGiftId"
            class="gift_item"
          >
            <gift-item-2
              :icon="gf.giftIcon"
              :name="''"
              :desc="gf.giftDesc"
              :tag="gf.rebateTag"
              :disabled="gf.drawStatus === 2"
              :btnText="getBtnText(gf)"
              @receive="handleReceive(gf)"
              @disableClick="handleClickDisable(gf)"
            />
          </div>
        </div>
        <div
          class="gift_wrap_vague"
          :style="{
            background: `linear-gradient(0deg, #314cab 0%, transparent 100%)`
          }"
        ></div>
      </div>
      <Popup
        :visible.sync="visible"
        v-bind="feedback"
        confirmButtonColor="#FFD242"
        cancelButtonColor="#FFD242"
        :progressAttrs="progressAttrs"
        :skins="{
          progressColor: {
            inner: '#94E1F8',
            text: '#E72D9F',
            border: '#8472F7'
          },
          headerBg: '#8472F7'
        }"
        @confirm="feedback.onSure"
        @cancel="feedback.onCancel"
      >
        <template v-if="feedbackType === 0">
          <div class="color_normal fs_16 text_center scale08_center">
            <p>礼包码已存放在</p>
            <p style="color: #e72d9f">【我的礼包】--【活动礼包】</p>
          </div>
        </template>
      </Popup>
    </div>
    <RulePopup
      ref="ruleRef"
      :ruleText="actInfo.rule"
      :popAttrs="rulePopAttrs"
    />
    <GuidePopup
      ref="guideRef"
      :pic="actInfo.pic"
      :popAttrs="rulePopAttrs"
      @confirm="handleConfirmPopup"
    />
  </div>
</template>

<script>
import { getPayAmountInfo, receivePayAmountGift } from '@/apis/activity.api'
import store from "@/store";
import parseQuery from '@/mixins/parseQuery'
import giftItem2 from './giftItem2.vue';
import dayjs from 'dayjs';
import GuidePopup from '@/components/GuidePopup'
import { getGameInfoById } from '@/apis/common.api' 
import RulePopup from '@/components/RulePopup.vue';
import Popup from '@/components/Popup.vue';
import trackingMixin, { EVENT_TYPE_ENUM } from "@/mixins/tracking"; 
export default {
  components: { giftItem2, GuidePopup, RulePopup, Popup },
  mixins: [parseQuery, trackingMixin],
  data () {
    return {
      pic: '',
      gameName: '',
      actInfo: {},
      fields: ['activityId', 'gameId'],
      curGift: {},
      receiveLoading: false,
      visible: false,
      feedbackType: 0,
      progressAttrs: {
        currentVal: 5,
        targetVal: 100,
      },
      rulePopAttrs: {
        confirmButtonColor: "#FFD242",
        skins: {
          headerBg: "#8472F7"
        },
      },
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    countdown () {
      const { endTime, activityStatus } = this.actInfo
      const endDate = dayjs(endTime)
      if (!endTime || activityStatus !== 1) return ''
      const currentTime = new Date()
      const totalHours = Math.ceil(endDate.diff(currentTime, 'hours', true))
      const day = Math.floor(totalHours / 24)
      const hour = totalHours - day * 24
      return day.toString().padStart(2, '0') + '天' + hour.toString().padStart(2, '0') + '时'
    },
    status () {
      // return 2
      return this.actInfo.activityStatus
    },
    bindUser () {
      return this.actInfo.bindUser
    },
    giftList () {
      return this.actInfo.giftVos || []
    },
    feedbackMap () {
      return [
        {
          title: '领取成功',
          confirmButtonText: '去复制礼包码',
          showCancelButton: true,
          cancelButtonText: '再看看',
          message: [],
          onSure: () => {
            const { giftId, giftName } = this.curGift
            this.EVENT_TRACKING(
              EVENT_TYPE_ENUM.wechat_pay_activity_copy_cdk_button,
              {
                ...this.trackActInfo,
                welfare_id: giftId,
                gift_name: giftName,
                accumulative_pay: this.actInfo.accumulative_pay
              },
              this.trackAppInfo
            )
            this.triggerVisible(false)
            this.handleGoMyGift()
          },
          onCancel: () => {
            const { giftId, giftName } = this.curGift
            this.EVENT_TRACKING(
              EVENT_TYPE_ENUM.wechat_pay_activity_see_button,
              {
                ...this.trackActInfo,
                welfare_id: giftId,
                gift_name: giftName,
                accumulative_pay: this.actInfo.accumulative_pay
              },
              this.trackAppInfo
            )
            this.triggerVisible(false)
          }
        },
        {
          title: '不满足领取条件',
          showConfirmButton: false,
          showProgress: true,
          message: [
            `活动期间充值满${this.progressAttrs.targetVal}元领取`
          ],
          onSure: () => {},
          onCancel: () => {},
        },
      ]
    },
    feedback () {
      return this.feedbackMap[this.feedbackType]
    },
    // 埋点所需的活动信息
    trackActInfo () {
      return {
        activity_id: this.params.activityId,
        activity_name: this.actInfo.name,
      }
    },
    trackAppInfo () {
      return {
        appkey: this.actInfo.gameId,
        appName: this.actInfo.gameName,
      }
    },
  },
  methods: {
    init () {
      this.getMainInfo()
    },
    getMainInfo (hasEvent = true) {
      return getPayAmountInfo({
        wxappid: this.$storeGet('WX_APP_ID'),
        openid: store.getters['user/openid'],
        activityId: this.params.activityId,
      }).then(res => {
        this.actInfo = res.data
        const { name, bindUser, white, rechargeMoney } = res.data
        document.title = name
        if (hasEvent) {
          // "1-未获取角色 2-非白名单 3-白名单"
          const page_type = bindUser ? (white ? 3 : 2) : 1
          this.EVENT_TRACKING(
            EVENT_TYPE_ENUM.wechat_pay_activity_home,
            {
              ...this.trackActInfo,
              page_type,
              accumulative_pay: page_type === 3 ? rechargeMoney : undefined
            },
            this.trackAppInfo
          )
        }
        this.$nextTick(() => {
          if (this.status === 1 && !this.bindUser) {
            this.EVENT_TRACKING(
              EVENT_TYPE_ENUM.wechat_pay_activity_not_bin_user_pop,
              this.trackActInfo,
              this.trackAppInfo
            )
            this.$refs.guideRef.triggerVisible(true)
          }
        })
      })
    },
    handleReceive (gf) {
      if (this.receiveLoading) return
      this.receiveLoading = true
      const { activityGiftId, giftId, giftName, drawStatus } = gf
      this.curGift = gf
      const eventName = drawStatus === 1 ? 'wechat_pay_activity_gift_wait_draw_button' : 'wechat_pay_activity_gift_wait_unlock_button'
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM[eventName],
        {
          ...this.trackActInfo,
          accumulative_pay: this.actInfo.rechargeMoney,
        },
        this.trackAppInfo
      )
      return receivePayAmountGift({
        wxappid: this.$storeGet('WX_APP_ID'),
        openid: store.getters['user/openid'],
        activityId: this.params.activityId,
        activityGiftId,
      }).then(res => {
        const { cdk } = res.data
        if (cdk) {
          this.receiveGiftCallback()
          this.EVENT_TRACKING(
            EVENT_TYPE_ENUM.wechat_pay_activity_draw_gift_success_pop,
            {
              ...this.trackActInfo,
              welfare_id: giftId,
              gift_name: giftName, 
              accumulative_pay: this.actInfo.rechargeMoney,
            },
            this.trackAppInfo
          )
          // 更新列表
          this.getMainInfo(false)
        } else {
          this.$toast('礼包码已领完')
        }
      }).catch(err => {
        const { code, msg } = err
        if (code === 1106) {
          this.triggerVisible(true)
          this.feedbackType = 1
          const [a, b] = msg.split('/')
          this.progressAttrs.currentVal = a * 1
          this.progressAttrs.targetVal = b * 1

          this.EVENT_TRACKING(
            EVENT_TYPE_ENUM.wechat_pay_activity_draw_not_complete_pop,
            {
              ...this.trackActInfo,
              welfare_id: giftId,
              gift_name: giftName,
              target: b * 1,
              current: a * 1
            },
            this.trackAppInfo
          )
        }
      }).finally(() => this.receiveLoading = false)
      
    },
    // 1-待领取 2-已领取 3-未满足条件
    handleClickDisable (gift) {
      const { drawStatus } = gift
      this.curGift = gift
      if (drawStatus !== 2) return
      this.receiveGiftCallback()
    },
    receiveGiftCallback () {
      this.feedbackType = 0
      this.triggerVisible(true)
    },
    getBtnText (gf) {
      const { drawStatus, money } = gf
      if (drawStatus === 1) return '待领取'
      if (drawStatus === 2) return '已领取'
      return `充值\n${money}解锁`
    },
    handleGetGameInfo () {
      return getGameInfoById({
        gameId: this.params.gameId
      }).then(res => {
        const { pic, name } = res.data
        this.pic = pic
        this.gameName = name
      })
    },
    handleShowRule (t) {
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_pay_activity_rule_button,
        {
          ...this.trackActInfo,
          page_type: t
        },
        this.trackAppInfo
      )
      this.$refs.ruleRef.triggerVisible(true)
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_pay_activity_rule_pop,
        this.trackActInfo,
        this.trackAppInfo
      )
    },
    handleConfirmPopup () {
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_pay_activity_know_button,
        this.trackActInfo,
        this.trackAppInfo
      )
    },
    triggerVisible (v) {
      this.visible = v
    },
    handleGoMyGift () {
      this.$router.push({
        name: 'myGift',
        query: {
          tab: 2,
          gameId: this.actInfo.gameId,
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.wrap {
  background-color: #314cab;
}
.header {
  width: 100%;
  // height: 226px;
  img {
    width: 100%;
  }
}
.right_top {
  position: absolute;
  top: 40px;
  right: 20px;
}

.account {
  width: 100%;
  img {
    width: 100%;
  }
  .amount {
    width: 140px;
    position: absolute;
    right: 74px;
    bottom: 58px;
    color: #FBFD00;
    text-align: center;
    .amount_symbol {
      transform: translateY(-100%);
    }
    .amount_digit {
      font-size: 36px;
    }
    .fs_28 {
      font-size: 28px;
    }
  }
  .amount_top {
    position: absolute;
    top: -14px;
    width: 100%;
  }
}
.gift_wrap {
  width: 100%;
  height: 732px;
  padding: 96px 21px 16px;

  .gift_wrap_vague {
    position: absolute;
    bottom: 5px;
    width: 100vw;
    left: -0px;
    height: 10px;
    z-index: 1;
  }

  .time {
    width: 212px;
    height: 51px;
    color: #ffffff;
    text-shadow: 0px 0px 1.74px 0px rgba(17,11,91,0.74); 
    .time_content {
      position: absolute;
      left: 68px;
      top: 20px;
      font-size: 12px;
      white-space: nowrap;
    }
  }
  .gift_list {
    width: 100%;
    padding: 12px 3px;
    height: calc(100% - 52px - 8px + 8px);
    overflow: auto;
    .gift_item + .gift_item {
      margin-top: 16px;
    }
  }
}
</style>